import React from 'react'
// import { printType } from '../../constants/orderType'

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth'
const BRAND = process.env.REACT_APP_BRAND || 'dw'

const InvoiceFooter = () => (
    <div className="invoice-payment">
        {CLIENT === 'woodworth' && (
            <div>
                <div>Payment Options:</div>
                <p>
                    1) Cheque, $45 service charge levied on all returned
                    cheques.
                </p>
                <p>2) Email transfer to sales@de-valor.ca.</p>
                <p>3) Credit Card payment is subject to 2.0% of surcharge.</p>
                <p>4) Debit Card no Charge.</p>
            </div>
        )}
        {CLIENT === 'dw' && (
            <div className="payment-section">
                <h3 className="payment-title">Payment Options</h3>

                <div className="payment-item">
                    <p className="payment-number">1. Cheque</p>
                    <p className="payment-note">
                        A service charge of $45 will be levied on all returned
                        cheques.
                    </p>
                </div>

                <div className="payment-item">
                    <p className="payment-number">2. Zelle Transfer</p>
                    <p className="payment-note">
                        Send payment to:{' '}
                        {BRAND === 'dw'
                            ? 'sales@dw-cabinetry.com'
                            : 'info@dwc-nj.com'}
                    </p>
                </div>

                <div className="payment-item">
                    <p className="payment-number">3. Credit Card</p>
                    <p className="payment-note">
                        A surcharge of 3.0% will be applied to all credit card
                        payments.
                    </p>
                </div>

                <div className="payment-item">
                    <p className="payment-number">4. Debit Card</p>
                    <p className="payment-note">
                        No additional charge applies for debit card payments.
                    </p>
                </div>

                <div className="payment-item">
                    <p className="payment-number">
                        5. ACH Payment (Bank Transfer)
                    </p>
                    <ul className="payment-list">
                        <li>
                            <strong>Bank:</strong>{' '}
                            {BRAND === 'dw'
                                ? 'Bank of America'
                                : 'JP Morgan Chase'}
                        </li>
                        <li>
                            <strong>Routing Number:</strong>{' '}
                            {BRAND === 'dw' ? '026009593' : '0211202337'}
                        </li>
                        <li>
                            <strong>Account Number:</strong>{' '}
                            {BRAND === 'dw' ? '4881 1777 7644' : '706598763'}
                        </li>
                    </ul>
                </div>
            </div>
        )}
        {/* 
        {type === printType.INVOICE && CLIENT === 'dw' && (
            <div style={{ marginTop: '30px' }}>
                <div style={{ textAlign: 'center' }}>
                    <img
                        src="https://res.cloudinary.com/homespace/image/upload/v1726103745/Screenshot_2024-09-11_at_9.11.44_PM_pjzphf.png"
                        style={{ width: '100px', objectFit: 'contain' }}
                        alt="qr code"
                    />
                </div>
                <div style={{ textAlign: 'center' }}>Scan QR code to pay</div>
            </div>
        )} */}
    </div>
)

export default InvoiceFooter
